var Top = {
  // btn01用のオブジェクト
  wWidth: undefined,
  wHeight: undefined,
  logoFlg: false,
  flg: false,
  flg2: false,

  scrlVal: undefined,
  menuBtnY: undefined,
  sec05Y: undefined,
  ftrY: undefined,
  bottom: 300,

  ua: undefined,

  init:function () {
    this.loadYoutubeAPI();
  },

  loadYoutubeAPI: function(){

    // youtbe制御
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      var dfd = $.Deferred();

      window.onYouTubeIframeAPIReady = function(){
        dfd.resolve();
      };

    // yotubeが準備できたらapp関数起動
      dfd.done(this.topInit.bind(this));

  },

  topInit: function(){

    var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

    this.defineUa();


    // メインビジュアルがある場合のみ発動
    if($('#js-p-top-main-visual')[0]){
      // this.setGnavClass();

      // $(window).on('load',function(){
         $('html,body').animate({ scrollTop: 0 }, '1');
        this.getSize();
        this.setSize();
        this.resize();
        $('body').css('overflow','hidden');
        $('#p-top-first-logo').fadeIn(300);
        this.checkMenuPosition();
      // }.bind(this));

      this.youtubeInit();


// uaによってバインドするイベントを変更
      if(this.ua.Mobile || this.ua.Tablet){
        $(document).on('touchend',function(){
          this.fadeOutLogo();
        }.bind(this));
      } else {
        $('#p-top-first-logo').on('click',function(){
          this.fadeOutLogo();
        }.bind(this));
        $(document).on(mousewheelevent,function(){
          this.fadeOutLogo();
        }.bind(this));
      }
      $(window).on('scroll',function(){
        this.checkMenuPosition();
      }.bind(this));

    }
  },

  defineUa: function() {
    this.ua = (function(u){
      return {
        Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
          || u.indexOf("ipad") != -1
          || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
          || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
          || u.indexOf("kindle") != -1
          || u.indexOf("silk") != -1
          || u.indexOf("playbook") != -1,
        Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
          || u.indexOf("iphone") != -1
          || u.indexOf("ipod") != -1
          || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
          || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
          || u.indexOf("blackberry") != -1
      }
    })(window.navigator.userAgent.toLowerCase());
  },

  resize: function() {
    var timer = false;
    $(window).resize(function() {
        if (timer !== false) {
            clearTimeout(timer);
        }
        timer = setTimeout(function() {
          this.getSize();
          this.setSize();
        }.bind(this), 200);
    }.bind(this));
  },

  getSize: function() {
    this.wHeight = $(window).height();
  },

  setSize: function() {
    $('#js-p-top-main-visual').height(this.wHeight);
  },

  fadeOutLogo: function() {
    if(!this.logoFlg){
      var _sTop = $('.p-top-main-contents').offset().top;
      TweenMax.to($('#js-p-top-main-visual'),0.5,{
        opacity: 0,
        onComplete: function(){
          TweenMax.to($('html,body'),0,{
            scrollTop: _sTop,
            onComplete: function() {
              $('body').css('overflow-y','scroll');
              TweenMax.to($('.p-top-main-contents'),0.5,{
                opacity: 1,
                onStart: function() {
                  $('body').css('overflow-y','hidden');
                  $('#js-p-top-main-visual').css('opacity','1');
                },
                onComplete: function() {
                  $('body').css('overflow-y','scroll');
                }
              });
            }
          });
        }
      });
      this.logoFlg = true;
    }
  },

  setGnavClass: function() {
    $('#header').addClass('p-top-menu');
    $('#header').find('.c-gnav-inner').addClass('p-top-gnav-inner');
  },

  checkMenuPosition: function() {

    this.scrlVal = $(window).scrollTop();
    this.menuBtnY = $('#menu-trigger').offset().top;
    this.sec05Y = $('.p-top-section-04').offset().top;
    this.ftrY = $('#footer').find('.footer-inner-01').offset().top;

    if(this.menuBtnY - this.scrlVal > this.sec05Y - this.scrlVal){
      this.flg = true;
    } else {
      this.flg = false;
    }

    if(this.menuBtnY - this.scrlVal > this.ftrY - this.scrlVal){
      if(this.scrlVal - this.wHeight < this.ftrY) {
        this.flg2 = true;
        if(this.scrlVal - 50 < this.ftrY - this.wHeight) {
          this.flg2 = false;
        }
      }
    }

    this.addClass();
  },

// 再生リストの管理
    youtubeInit: function() {
      this.player = new YT.Player("top-youtube-player", {
        videoId: "E_oESwI5M9M",
        playerVars: {
          rel: 0,
        },
        events: {
          'onReady': this.onPlayerReady.bind(this)
        }
      });
    },

    onPlayerReady: function(){
      var _this = this;
      $('.js-top-youtube-btn').on('click',function(){
        $(this).fadeOut(200,function(){
          _this.player.playVideo();
        });
      });
    },


  addClass: function() {
    var $menuBtn = $('.menu-trigger');
    var $menu = $('.p-top-menu');

    if(this.flg){
      $menuBtn.addClass('is-bottom');
    } else {
      $menuBtn.removeClass('is-bottom');
    }

    if(this.flg2){
      $menu.addClass('is-in-footer');
    } else {
      $menu.removeClass('is-in-footer');
    }
  }

};



module.exports = Top;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_top.js
// module id = 10
// module chunks = 0